module.exports = __webpack_public_path__ + "assets/img/index-1.2975c30d.png";